import React, { useEffect } from "react";
import { Button } from "react-bulma-components";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
} from "lucide-react";

interface PaginationProps {
  currentPage: number;
  perPage?: number;
  setPerPage?: (perPage: number) => void;
  totalPages: number;
  onPageChange: (page: number) => void;
}

const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  perPage,
  setPerPage,
  totalPages,
  onPageChange,
}) => {
  if (totalPages <= 1 && !perPage) {
    return null; // Don't show pagination if there's only one page
  }

  return (
    <div className="flex items-center justify-center mt-6 gap-2">
      <Button
        variant="outline"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
        className="bg-gray-800 text-white hover:bg-gray-700 disabled:opacity-50"
      >
        <ChevronsLeft className="w-4 h-4" />
      </Button>
      <Button
        variant="outline"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
        className="bg-gray-800 text-white hover:bg-gray-700 disabled:opacity-50"
      >
        <ChevronLeft className="w-4 h-4" />
      </Button>
      <span className="text-gray-400">
        Página {currentPage} de {totalPages}
      </span>
      <Button
        variant="outline"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
        className="bg-gray-800 text-white hover:bg-gray-700 disabled:opacity-50"
      >
        <ChevronRight className="w-4 h-4" />
      </Button>
      <Button
        variant="outline"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
        className="bg-gray-800 text-white hover:bg-gray-700 disabled:opacity-50"
      >
        <ChevronsRight className="w-4 h-4" />
      </Button>
      {perPage && (
        <span className="text-gray-400 ml-4">
          {setPerPage ? (
            <>
              <span>Itens por página </span>
              <select
                value={perPage}
                onChange={(e) => setPerPage(Number(e.target.value))}
                className="bg-gray-800 text-white border border-gray-600 rounded px-2 py-1"
              >
                <option value={10}>10</option>
                <option value={20}>20</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
            </>
          ) : (
            <span>Mostrando {perPage} itens por página</span>
          )}
        </span>
      )}
    </div>
  );
};

export default Pagination;
